import React, { useEffect, useState } from "react";
import { useGetTableData2 } from "../Plan/tableHooks";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import LinearProgress from "@mui/material/LinearProgress";
import * as S from "./styles";
import EmptyState from "../common/EmptyState";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Refresh3 from "../Nucleo-Icons/icons/refresh-3";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";

const theme = createTheme();

function LeftSection({ onClose }) {
  const { group_code, project_code } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const { currentProgressData } = useGetTableData2(
    true,
    `/api/performance/getScheduledProgress?group_code=${group_code}&project_code=${project_code}`,
    "currentProgressData"
  );
  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (term.trim()) {
      const filtered = currentProgressData.filter(
        (order) =>
          order.order_name?.toLowerCase().includes(term.toLowerCase()) ||
          order.item_name?.toLowerCase().includes(term.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(currentProgressData);
    }
  };
  const handleReset = () => {
    setSearchTerm("");
    setFilteredData(currentProgressData);
  };
  useEffect(() => {
    if (!searchTerm) {
      setFilteredData(currentProgressData || []);
    }
  }, [currentProgressData, searchTerm]);
  return (
    <ThemeProvider theme={theme}>
      <S.LeftSectionContainer>
        <S.LeftTitle>
          일정계획 대상
          <S.CloseButton onClick={onClose}>
            <CloseIcon />
          </S.CloseButton>
        </S.LeftTitle>
        <S.SearchContainer>
          <TextField
            size="small"
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            variant="outlined"
            placeholder="검색어를 입력하세요"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <S.SearchActioIconBox onClick={handleReset}>
            <Refresh3 />
          </S.SearchActioIconBox>
        </S.SearchContainer>
        <S.LeftCardContainer>
          <CssBaseline />
          {filteredData.length ? (
            filteredData.map((order, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                >
                  <Typography
                    component="div"
                    variant="body2"
                    sx={{
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    {order.order_name}&nbsp;({order.qty}ea)
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <S.LeftStyledTypography
                    variant="body2"
                    gutterBottom
                    sx={{
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    {order.item_name}
                  </S.LeftStyledTypography>
                  <LinearProgress
                    variant="determinate"
                    value={Number(order.progress_result)}
                    sx={{
                      height: "10px",
                      ...(order.isProgressError && {
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#ff0000",
                        },
                      }),
                    }}
                  />
                  <S.LeftStyledTypography
                    variant="caption"
                    align="right"
                    sx={{
                      display: "block",
                      marginTop: "4px",
                      color: order.isProgressError ? "#ff0000" : "inherit",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    진행률:{" "}
                    {order.isProgressError
                      ? "오류"
                      : `${order.progress_result}%`}
                  </S.LeftStyledTypography>
                  <S.LeftStyledTypography
                    variant="caption"
                    align="right"
                    sx={{
                      display: "block",
                      marginTop: "4px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    시작: {order.start_date}
                  </S.LeftStyledTypography>
                  <S.LeftStyledTypography
                    variant="caption"
                    align="right"
                    sx={{
                      display: "block",
                      marginTop: "4px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    납기: {order.due_date}
                  </S.LeftStyledTypography>
                </AccordionDetails>
              </Accordion>
            ))
          ) : (
            <EmptyState />
          )}
        </S.LeftCardContainer>
      </S.LeftSectionContainer>
    </ThemeProvider>
  );
}

export default LeftSection;
